import React, {useEffect} from 'react';
import {ActivityIndicator, View} from 'react-native';

import {colorPalette} from '../../../core/config/color.config';

// TODO: replace with the real App Store URL once the app's numeric iTunes id
// is known (it cannot be derived from the bundle identifier).
const IOS_APP_STORE_URL = 'https://apps.apple.com/ph/app/housecall/idTODO';
const ANDROID_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=ph.telemedicine.housecall.app';

/**
 * Web-only landing for a doctor's profile share link
 * (`https://app.housecall.com.ph/dr/:practitionerId`).
 *
 * Android App Links / iOS Universal Links intercept this URL before it ever
 * reaches a browser when the app is installed, so this screen only renders
 * when the app is NOT installed. Its only job is to send the visitor to the
 * correct app store; it intentionally does not know or care which doctor
 * was shared.
 */
const DoctorProfileStoreRedirectScreen = () => {
  useEffect(() => {
    const userAgent =
      typeof navigator !== 'undefined' ? navigator.userAgent : '';
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const storeUrl = isIOS ? IOS_APP_STORE_URL : ANDROID_PLAY_STORE_URL;

    if (typeof window !== 'undefined') {
      window.location.replace(storeUrl);
    }
  }, []);

  return (
    <View style={{flex: 1, alignItems: 'center', justifyContent: 'center'}}>
      <ActivityIndicator size="large" color={colorPalette.primary} />
    </View>
  );
};

export default DoctorProfileStoreRedirectScreen;
